export const setCommitmentOrCertificateNumber = (number) => ({
    type: 'SET_COMMITMENT_OR_CERTIFICATE_NUMBER',
    payload: number
});
export const setLenderLoanNumber = (lenderLoanNumber) => ({
    type: 'SET_LENDER_LOAN_NUMBER',
    payload: lenderLoanNumber
});
export const setApplicationType = (applicationType) => ({
    type: 'SET_APPLICATION_TYPE',
    payload: applicationType
});
export const setStatus = (status) => ({
    type: 'SET_STATUS',
    payload: status
});
export const setStatusMessage = (statusMessage) => ({
    type: 'SET_STATUS_MESSAGE',
    payload: statusMessage
});
export const setReceivedDate = (receivedDate) => ({
    type: 'SET_RECEIVED_DATE',
    payload: receivedDate
});
export const setReceivedTime = (receivedTime) => ({
    type: 'SET_RECEIVED_TIME',
    payload: receivedTime
});
export const setPendedReasons = (pendedReasons) => ({
    type: 'SET_PENDED_REASONS',
    payload: pendedReasons
});
export const setSuspendReason = (suspendReason) => ({
    type: 'SET_SUSPEND_REASON',
    payload: suspendReason
});
export const setLastDocReceivedDateTime = (lastDocReceivedDateTime) => ({
    type: 'SET_LAST_DOC_RECEIVED_DATE',
    payload: lastDocReceivedDateTime
});
